import { useSelector } from "react-redux";
import AccessDenied from "../component/AccessDenied";
import { isTaskAllowed } from "../utils/isTaskAllowed";
import QuestionAnswer from "../component/QuestionAnswer";

const Questions = () => {
    const { admin } = useSelector((state) => state.auth);

    if(admin?.email !== "admin@thriftyx.com" &&
        !isTaskAllowed("Question Answer", admin?.assignedWork)) return (<AccessDenied />)

    return ( <QuestionAnswer /> ) 
}
export default Questions;